import React from "react";
import { Reveal } from "./Reveal";
import { useLang } from "../i18n";

export default function About() {
  const { t } = useLang();
  return (
    <section id="group" className="section-pad relative bg-ink">
      <div className="container-luxe grid items-center gap-16 lg:grid-cols-2">
        <div>
          <Reveal>
            <p className="overline mb-5">{t.about.overline}</p>
            <h2 className="font-serif text-3xl font-light leading-tight text-white sm:text-4xl lg:text-5xl">
              {t.about.title}
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-7 h-px w-24 gold-line" />
          </Reveal>
        </div>

        <div className="space-y-6">
          <Reveal delay={0.1}>
            <p className="text-base leading-relaxed text-white/65 md:text-lg">{t.about.p1}</p>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-base leading-relaxed text-white/65 md:text-lg">{t.about.p2}</p>
          </Reveal>
          <Reveal delay={0.3}>
            <blockquote className="border-l-2 border-gold pl-6 font-serif text-lg italic text-white/80 md:text-xl">
              {t.about.founder}
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
